<template>
  <button
    type="button"
    class="close-btn"
    :aria-label="ariaLabel"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  </button>
</template>

<script>
export default {
  name: "close-button",
  props: {
    ariaLabel: { type: String, default: "Close" },
  },
};
</script>

<style lang="scss" scoped>
.close-btn {
  width: 38px;
  height: 38px;
  border-radius: $radius-pill;
  background: $glass-strong;
  border: 1px solid $glass-stroke;
  backdrop-filter: $glass-blur-soft;
  -webkit-backdrop-filter: $glass-blur-soft;
  box-shadow: $shadow-chip;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  padding: 0;
  transition:
    transform $dur-fast $ease-bubble,
    box-shadow $dur-base $ease-soft,
    background $dur-base $ease-soft;

  svg { stroke: $ink-soft; }

  &:hover,
  &:focus-visible {
    transform: scale(1.05);
    background: $glass-edge;
  }

  &:active {
    transform: scale(0.94);
    box-shadow: $shadow-bubble-active;
  }
}
</style>
